export const COMMON_LOCALE_PART = 'common';
export const FAQ_LOCALE_PART = 'faq';
export const VOLUNTEER_LOCALE_PART = 'volunteer';
